import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSurveyPoint } from "./actions";
import "bootstrap/dist/css/bootstrap.css";
import "./css/style.css";
import End from "./End";
import axios from "axios";
import InvalidService from "./InvalidService";
import RateOption from "./RateOption";

export default function RateApp() {
  const { service_id, icrm_id, uuid } = useParams();

  const [data, setData] = useState({ rate: 0 });
  const [rate, setRate] = useState(0);
  const [comment, setComment] = useState("");
  const [device, setDevice] = useState("web");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isInvalidService, setIsInvalidService] = useState(false);
  const dispatch = useDispatch();
  const surveyCommentTag = useSelector((state) => state.surveyCommentTag);
  const endContentRef = useRef(null);

  useEffect(() => {
    if (uuid === "test") {
      setData({
        rate: 0,
        icrm_id: icrm_id,
        service_id: service_id,
      });
      return;
    }
    if (uuid === undefined) {
      setData({
        rate: 0,
        icrm_id: icrm_id,
        service_id: service_id,
      });
      setDevice("mobile");
      return;
    }
    async function fetchDataAPI() {
      const response = await axios.get(`${process.env.REACT_APP_URL_API}/surveydetail?uuid=${uuid}`, {
        headers: { "Access-Control-Allow-Origin": "*" },
      });
      if (response.data.status !== "FAIL") {
        setData(response.data.data);
        if (response.data.data.rate !== 0) {
          endContentRef.current.classList.remove("hide");
        }
      } else {
        setData({
          rate: 5,
        });
        endContentRef.current.classList.remove("hide");
      }
    }
    try {
      fetchDataAPI();
    } catch (error) {
      console.log(error);
    }
  }, [icrm_id, service_id, uuid]);

  const handleRating = (value) => {
    setRate(value);
    dispatch(setSurveyPoint(value));
  };
  const handleComment = (event) => {
    setComment(event.target.value);
  };
  const handleSendRating = () => {
    if (rate !== 0) {
      saveRating();
    }
  };

  const [btnDisabled, setBtnDisabled] = useState(false);

  const saveRating = () => {
    setBtnDisabled(true);
    async function saveDataAPI() {
      await axios
        .post(`${process.env.REACT_APP_URL_API}/insert`, {
          icrm_id: data.icrm_id,
          service_id: data.service_id,
          rate: rate,
          comment: comment,
        })
        .then(function (response) {
          if (response.data.status === "FAIL") {
            setIsInvalidService(true);
          }
          endContentRef.current.classList.remove("hide");
          setIsSubmit(true);
          setBtnDisabled(false);
        })
        .catch(function (error) {
          console.log(error);
          setIsSubmit(false);
          setIsInvalidService(false);
          setBtnDisabled(false);
        });
    }
    saveDataAPI();
  };

  useEffect(() => {
    setComment("");
  }, [rate]);

  useEffect(() => {
    if (surveyCommentTag !== "") {
      var ele = document.getElementById("comment").value;
      var txt = `${ele}${surveyCommentTag}`;
      setComment(txt.trim() + " ");
    }
  }, [surveyCommentTag]);

  return (
    <>
      <nav className={`navbar navbar-light bg-light ${device === "mobile" ? "hide" : ""}`}>
        <h1 className="navbar-brand navbar-brand-rate">ประเมินการให้บริการของล่ามภาษามือ</h1>
      </nav>
      <div id="endContent" className="hide" ref={endContentRef}>
        {isSubmit && !isInvalidService && <End />}
      </div>
      {isInvalidService && <InvalidService />}
      <RateOption
        handleComment={handleComment}
        handleRating={handleRating}
        handleSendRating={handleSendRating}
        rate={rate}
        data={data}
        isSubmit={isSubmit}
        comment={comment}
        disabled={btnDisabled}
      />
    </>
  );
}
